export default "<!-- {{ value | currency:currencyCode:'symbol':'0.2-4' }} -->\n{{ value | currency:currencyCode:'symbol':'0.2-2' }}\n\n"